import { jsx as a, jsxs as r, Fragment as l } from "react/jsx-runtime";
import { memo as c } from "react";
import { Upload as m } from "antd";
import { R as n } from "../../../../../../InboxOutlined-rrW4rM7l.js";
const { Dragger: s } = m, i = ({ uploadProps: e, children: t }) => {
  const { accept: o } = e;
  return /* @__PURE__ */ a("div", { className: "at-size-full at-max-h-[30rem]", children: /* @__PURE__ */ a(s, { ...e, children: t || /* @__PURE__ */ r(l, { children: [
    /* @__PURE__ */ a("p", { className: "ant-upload-drag-icon", children: /* @__PURE__ */ a(n, {}) }),
    /* @__PURE__ */ a("p", { className: "ant-upload-text", children: "點擊或拖曳文件到這裡上傳" }),
    o ? /* @__PURE__ */ r("p", { className: "ant-upload-hint", children: [
      "支持 ",
      o,
      " 類型檔案"
    ] }) : ""
  ] }) }) });
}, u = c(i);
export {
  u as default
};
